// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2x8pu","fileBtn":"File_fileBtn__1IZUK","closeBtn":"File_closeBtn__3HYbn","fileSelected":"File_fileSelected__3FkSZ","disabled":"File_disabled__1BUhf"};